import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';
import { MdbModalRef } from 'mdb-angular-ui-kit/modal';
import { Editor, Toolbar, schema } from 'ngx-editor';
import { Contact } from 'src/app/models/contact.model';
import { ContactService } from 'src/app/services/contact.service';

@Component({
  selector: 'app-kontakt-modal',
  templateUrl: './kontakt-modal.component.html',
  styleUrls: ['./kontakt-modal.component.sass'],
  providers: [ContactService]
})
export class KontaktModalComponent implements OnInit, OnDestroy {

  public editor_text: Editor;
  public html_text: string = '';
  public toolbar: Toolbar = [
    ['bold', 'italic'],
    ['underline', 'strike'],
    ['code', 'blockquote'],
    ['ordered_list', 'bullet_list'],
    [{ heading: ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'] }],
    ['link'],
    ['text_color', 'background_color'],
    ['align_left', 'align_center', 'align_right', 'align_justify'],
  ];

  public operation?: string;
  public contactToEdit?: Contact;
  public form: FormGroup = new FormGroup(
    {
      text: new FormControl('', Validators.required),
    }
  );

  constructor(public modalRef: MdbModalRef<KontaktModalComponent>,
    public fb: FormBuilder,
    private contactService: ContactService) {
    this.editor_text = new Editor();
  }


  ngOnInit(): void {

    if (this.contactToEdit) {
      this.form = new FormGroup(
        {
          text: new FormControl(this.contactToEdit.text || '', Validators.required),
        }
      )
      this.html_text = this.contactToEdit.text
    }
  }

  get f() {
    return this.form.controls;
  }

  close(): void {
    this.modalRef.close(this.form)
  }

  submit() {
    if (this.form.valid) {
      if (this.operation) {
        if (this.contactToEdit) {
          const newContact = {
            text: this.f.text.value,
          }
          this.contactService.updateContact(this.contactToEdit, newContact)
          this.modalRef.close(this.form);
        }
      }
      else {

        const newContact = {
          text: this.f.text.value,
        }
        this.contactService.addContact(newContact)
        this.modalRef.close(this.form);
      }
    }
    else {
      const newContact = {
        text: this.f.text.value,
      }
      this.contactService.addContact(newContact)
      this.modalRef.close(this.form);

    }
  }
  ngOnDestroy(): void {
    if(this.editor_text)
    this.editor_text.destroy();
  }
}



